module.exports = __webpack_public_path__ + "static/media/icon-github.bf0b63c8.svg";